import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuCatalogCreatePayload,
	IActionMenuCatalogCreatePayloadDone,
	IActionMenuCatalogCreatePayloadError,
} from './types';

export const menuCatalogCreate = actionCreatorAsync<
	IActionMenuCatalogCreatePayload,
	IActionMenuCatalogCreatePayloadDone,
	IActionMenuCatalogCreatePayloadError
>(
	'menuCatalogCreate',
	async (params) => {
		const { meal, title } = params;
		const { data } = await Api.menuCatalog.create({
			body: { meal, title },
		});

		return data;
	},
);
